export const enum auths {
  none,
  required,
  noRequired,
}

export const enum actors {
  none,
  buyer,
  exhibitor,
  admin,
}
